/**
 * Guest — Welcome-link auto-login handler.
 *
 * Route: /loyalty/welcome/:token
 *   Calls GET /api/loyalty/guest/welcome-link/:token
 *   - ok=true  → store session_token in sessionStorage → navigate to redirect_to
 *   - ok=false → navigate to redirect_to (standard login flow)
 */
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = 'loyalty_session_token';

export default function LoyaltyWelcomeLink() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking');   // checking | ok | fallback

  useEffect(() => {
    axios.get(`${API}/api/loyalty/guest/welcome-link/${token}`)
      .then((r) => {
        const { ok, session_token, redirect_to } = r.data || {};
        if (ok && session_token) {
          sessionStorage.setItem(SESSION_KEY, session_token);
          setStatus('ok');
          navigate(redirect_to || '/loyalty', { replace: true });
        } else {
          setStatus('fallback');
          navigate(redirect_to || '/loyalty', { replace: true });
        }
      })
      .catch(() => {
        setStatus('fallback');
        navigate('/loyalty', { replace: true });
      });
  }, [token, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center"
         style={{ background: '#FBF7EC' }}
         data-testid="welcome-link-loading">
      <div className="text-center space-y-3">
        <div className="animate-pulse text-lg font-serif" style={{ color: 'var(--color-primary)' }}>
          Signing you in…
        </div>
        <div className="text-xs text-gray-500">
          {status === 'fallback'
            ? 'This link has expired — redirecting to the standard login…'
            : 'Preparing your wallet.'}
        </div>
      </div>
    </div>
  );
}
